import { PS_EVENT_SESSION_EXTEND } from "../config/common";
import { TOKEN_EXCHANGE_ID } from "../config/tokens";
import { ps } from "../components/Application/Application";
import { setData as setDataAuth } from "../store/actions/auth";
import { setData as setDataProfile } from "../store/actions/profile";
import store from "../store";
import {
	API_NSP_AUTH,
	API_NSP_OPERATION_TOKEN_EXCHANGE,
	API_NSP_OPERATION_VERIFY,
	API_NSP_PROFILE,
	getApiUrl
} from "../config/api";
import {
	isFunction,
	isObject,
	isStringOfLength,
	sendRequest,
	tokenReplacement
} from "@pheaa/channels-component-library";

const commonApiRequest = ({ nsp, operation, tokenReplacements }, { errorCallback, extendSessionOnSuccess = false, headers = {}, successCallback, ...rest } = {}) => {

	let commonErrorCallback;
	let commonSuccessCallback;
	let endpoint = getApiUrl(nsp, operation, tokenReplacements);
	let includeAuthorizationHeader = true;
	const { auth } = store.getState();

	if (nsp === API_NSP_AUTH) {
		// Token Exchange and Verify operations are not using Cognito Authorizer;
		if (operation === API_NSP_OPERATION_TOKEN_EXCHANGE || operation === API_NSP_OPERATION_VERIFY) {
			includeAuthorizationHeader = false;
		}
	}

	if (isStringOfLength(auth.tokenExchangeId) && endpoint.indexOf(TOKEN_EXCHANGE_ID) >= 0) {
		endpoint = tokenReplacement(endpoint, TOKEN_EXCHANGE_ID, auth.tokenExchangeId);
	}

	if (includeAuthorizationHeader && isObject(auth) && isObject(auth.tokens) && isStringOfLength(auth.tokens.accessToken)) {
		// Update to use auth.tokens.accessToken if IAM system uses accessToken for token verification;
		headers["Authorization"] = auth.tokens.idToken;
	}

	commonErrorCallback = callbackData => {
		const { status } = callbackData;

		if (status === 409) {
			nsp === API_NSP_PROFILE && store.dispatch(setDataProfile({ isMaintenanceMode: true }));
		}

		isFunction(errorCallback) && errorCallback(callbackData);
	};

	commonSuccessCallback = callbackData => {

		let { tokens, ...responseBody } = callbackData;

		if (isObject(tokens)) {
			store.dispatch(setDataAuth({ tokens }));
		}

		isFunction(successCallback) && successCallback(responseBody);
		extendSessionOnSuccess && ps.publish(PS_EVENT_SESSION_EXTEND);
	};

	return sendRequest(endpoint, {
		...rest,
		errorCallback: commonErrorCallback,
		headers,
		successCallback: commonSuccessCallback
	});
};

export default commonApiRequest;